import { createAsyncThunk } from "@reduxjs/toolkit";
import { addTeamMemberApi, editTeamMemberApi, getTeamMembersApi } from "helpers/ApiManager";
import { ApiResponse, PaginatedPayload } from "types/ApiResponse";

import {
  AddTeamMemberArgs,
  EditTeamMemberArgs,
  GetTeamMembersApiArgs,
  TeamMember,
} from "types/team.api";
import { ErrorHandler, SuccessToast } from "utils/toast";

export const getTeamMembers = createAsyncThunk<
  ApiResponse<PaginatedPayload<TeamMember>>, // return type
  GetTeamMembersApiArgs | undefined, // argument type
  { rejectValue: string } // rejected type
>("teamMember/getTeamMembers", async (params, { rejectWithValue }) => {
  try {
    console.log("Fetching with params:", params);
    const response = await getTeamMembersApi(params);
    console.log(response);
    return response;
  } catch (err: any) {
    console.log(err);
    return rejectWithValue(err?.message || "Failed to fetch");
  }
});

// export const deleteSection = createAsyncThunk<
//   ApiResponse<number>, // return type
//   DeleteSectionArgs,
//   { rejectValue: string } // rejected type
// >("proposal-document/deleteSection", async (params, { rejectWithValue }) => {
//   try {
//     const response = await deleteSectionApi(params);
//     response.payload = params.sectionId;
//     SuccessToast(response.message);
//     return response;
//   } catch (err: any) {
//     ErrorHandler(err);
//     return rejectWithValue(err?.message || "Failed to delete");
//   }
// });

export const addTeamMember = createAsyncThunk<
  ApiResponse<TeamMember>, // return type
  AddTeamMemberArgs, // argument type
  { rejectValue: string } // rejected type
>("proposal-document/addSection", async (params, { rejectWithValue }) => {
  try {
    const response = await addTeamMemberApi(params);
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to add");
  }
});

export const editTeamMember = createAsyncThunk<
  ApiResponse<TeamMember>, // return type
  EditTeamMemberArgs, // argument type
  { rejectValue: string } // rejected type
>("proposal-document/editSection", async (params, { rejectWithValue }) => {
  try {
    const response = await editTeamMemberApi(params);
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to edit");
  }
});
